"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.materializeReceivableResponseTapePreviewChangeset = exports.createReceivableResponseTapePreviewArtifact = void 0;
const remeda_1 = require("remeda");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const createReceivableResponseTapePreviewArtifact = ({ artifactDocumentId, loanProductSlugs, }) => {
    return {
        id: (0, uuid_1.v4)(),
        type: 'receivableResponseTapePreview',
        configuration: {},
        loanProductSlug: null,
        creditFacilitySlug: null,
        artifactDocumentId,
        externalFilename: null,
        artifactSlug: `receivableResponseTapePreview_${loanProductSlugs.join('|')}`,
    };
};
exports.createReceivableResponseTapePreviewArtifact = createReceivableResponseTapePreviewArtifact;
const materializeReceivableResponseTapePreviewChangeset = ({ loanProductSlugs, masterLoanTapes, }) => {
    const artifactDocumentId = utils.parseArtifactDocumentId(masterLoanTapes);
    const receivableResponseTapePreview = (0, exports.createReceivableResponseTapePreviewArtifact)({ artifactDocumentId, loanProductSlugs });
    const receivableResponseTapePreviewDependencies = [];
    (0, remeda_1.forEach)(loanProductSlugs, (loanProductSlug) => {
        const filterMasterLoanTapes = (0, remeda_1.filter)(masterLoanTapes, (mlt) => mlt.loanProductSlug === loanProductSlug);
        (0, common_1.finleyAssert)(filterMasterLoanTapes.length === 1, `unable to find single master loan tape by ${loanProductSlug} for masterLoanTape type`);
        const masterLoanTape = filterMasterLoanTapes[0];
        receivableResponseTapePreviewDependencies.push({
            outputArtifactId: receivableResponseTapePreview.id,
            inputArtifactId: masterLoanTape.id,
        });
    });
    return {
        receivableResponseTapePreview,
        receivableResponseTapePreviewDependencies,
    };
};
exports.materializeReceivableResponseTapePreviewChangeset = materializeReceivableResponseTapePreviewChangeset;
//# sourceMappingURL=receivableResponseTapePreview.js.map